export const GET_CURRENT_TRANSACTION = `https://us-central1-e-submission-ec3cf.cloudfunctions.net/api/form`;